<script setup lang="ts">
import type { NabooContentLearningCourse } from '@/core/domain/nabooContent/NabooContent.ts'
import { defineProps, type Ref, ref } from 'vue'
import CNabooContentListCoursesCard from '@/presentation/components/content/CNabooContentListCoursesCard.vue'
import CBaseBlock from '@/presentation/components/base/CBaseBlock.vue'

// PROPS
const props = defineProps<{
  learningCourses: NabooContentLearningCourse[]
}>()

console.log('learningCourses', props.learningCourses)
</script>

<template>
  <div class="w-full">
    <c-base-block
      :multiple="true"
      class="my-4"
      toggleable
      v-for="course in props.learningCourses"
      :key="course.id"
      text
    >
      <template #title>
        <div
          class="vertical-align flex flex-initial flex-row flex-wrap content-center items-center justify-start gap-4"
        >
          <h4 class="flex-auto text-lg font-bold">Parcours - {{ course.title }}</h4>
        </div>
      </template>
      <div class="grid grid-cols-12 gap-4">
        <c-naboo-content-list-courses-card
          v-for="child in course.children"
          :key="`card_${child.id}_${child.order}`"
          :children="child"
        />
      </div>
    </c-base-block>
  </div>
</template>
